import { fg } from '@atlaskit/platform-feature-flags';
import {
	type GqlSuccessResponse,
	performGqlFetch,
} from '@atlassian/conversation-assistant-utils/graphqlUtils';

export type ScenarioActionNode = {
	actionKey: string;
	name: string;
	description: string;
	iconUrl: string;
	tags?: string[];
};

export type ScenarioToolNode = {
	id: string;
	displayName: string;
	description: string;
	iconUrl: string;
	tags?: string[];
};

export type ScenarioKnowledgeSourceSource = {
	enabled?: boolean;
	source: string;
	cloudId?: string | null;
	filters?: {
		spaceFilter?: string[];
		parentFilter?: string[];
		projectFilter?: string[];
	};
};

export type ScenarioKnowledgeSourceNode = {
	enabled?: boolean;
	sources?: ScenarioKnowledgeSourceSource[];
};

export type McpServerNode = {
	id: string;
	displayName: string;
	iconUrl: string;
};

export type McpToolNode = {
	id: string;
	displayName: string;
	iconUrl: string;
};

export type ScenarioNode = {
	id: string;
	name: string;
	instructions?: string;
	scenarioVersion: number;
	isDefault: boolean;
	isActive: boolean;
	isValid?: {
		value: boolean;
	};
	actions?: ScenarioActionNode[];
	tools?: ScenarioToolNode[];
	knowledgeSources?: ScenarioKnowledgeSourceNode;
	mcpServers?: (McpServerNode | null)[];
	mcpTools?: (McpToolNode | null)[];
	isDeepResearchEnabled?: boolean;
	isWebSearchEnabled?: boolean;
};

export type ScenarioList = {
	agentStudio_scenarioListByContainerId: {
		edges: {
			node: ScenarioNode;
		}[];
	};
};

/**
 * @deprecated please use relay to get these data instead
 */
export const fetchScenarioListFromAgg = async ({
	agentId,
	cloudId,
}: {
	agentId: string;
	cloudId: string;
}): Promise<GqlSuccessResponse<ScenarioList>> => {
	const gqlQuery = `
		query ScenarioList($agentId: ID!, $cloudId: String!, $first: Int) {
			agentStudio_scenarioListByContainerId(containerId: $agentId, cloudId: $cloudId, first: $first) {
				edges {
					node {
						id
						name
						instructions
						scenarioVersion
						isDefault
						isActive
						isValid {
							value
						}
						actions {
							actionKey
        					name
							description
							iconUrl
							tags
						}
						tools {
							id
							displayName
							description
							iconUrl
							tags
						}
						knowledgeSources {
							enabled
							sources {
								enabled
								source
								${fg('rovo_agents_unit_scoped') ? 'cloudId' : ''}
								filters {
									... on AgentStudioConfluenceKnowledgeFilter {
										spaceFilter
										parentFilter
									}
									... on AgentStudioJiraKnowledgeFilter {
										projectFilter
									}
								}
							}
						}
						mcpServers {
							id
							displayName
							iconUrl
						}
						mcpTools {
							id
							displayName
							iconUrl
						}
						isDeepResearchEnabled
						isWebSearchEnabled
					}
				}
			}
		}
	`;

	const response = await performGqlFetch<
		ScenarioList,
		{ agentId: string; cloudId: string; first: number }
	>({
		gqlQuery,
		variables: {
			agentId,
			cloudId,
			first: 5,
		},
	});

	return response;
};
